module.exports = __webpack_public_path__ + "img/zko7.e39dcebb.jpg";